import React, { useState } from 'react'

import { useParams } from 'utils/hooks'
import { useGroup } from 'redux/hooks/Groups'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Divider from 'components_new/atoms/Divider'

import FormSection from 'components_new/molecules/FormSection'
import GenericListItem from 'components_new/molecules/GenericListItem'

import DeleteDialog from 'components_new/organisms/dialogs/DeleteDialog'
import GroupSettingsForm from 'components_new/organisms/GroupSettingsForm'

import GroupTemplate from 'components_new/templates/GroupTemplate'

import { useGroupActions } from 'redux/actions/Groups'
import { useHistory } from 'react-router-dom'

const GroupSettings = () => {
  const params = useParams<{ id: string }>()
  const { t } = useTranslation()
  const { tryDeleteGroup } = useGroupActions()

  const group = useGroup(params.id)
  const history = useHistory()

  const [deleteGroupDialogOpen, setDeleteGroupDialogOpen] =
    useState<boolean>(false)

  if (!group) {
    return null
  }

  return (
    <>
      <GroupTemplate
        subpage={{ icon: { name: 'Settings' }, title: t('global', 'settings') }}
      >
        <GroupSettingsForm group={group} />

        <Divider sx={{ my: 2 }} />

        <FormSection
          actions={
            <Button
              color="error"
              onClick={() => setDeleteGroupDialogOpen(true)}
              variant="outlined"
            >
              {t('global', 'delete')}
            </Button>
          }
          helperText={t('groups', 'delete_group_helper_text')}
          size="small"
          title={t('groups', 'delete_group')}
        />
      </GroupTemplate>

      <DeleteDialog
        open={deleteGroupDialogOpen}
        onClose={() => setDeleteGroupDialogOpen(false)}
        onDelete={(cb) => {
          if (!group) return

          tryDeleteGroup(group.id, (err) => {
            if (!err) {
              setDeleteGroupDialogOpen(false)
              history.push('/groups')
            }
            cb()
          })
        }}
        title={
          <Box sx={{ display: 'inline-block' }}>
            <GenericListItem
              color={group.profile_color}
              component="div"
              disablePadding={true}
              size="small"
              title={group.name}
              variant="group"
            />
          </Box>
        }
        type={t('groups', 'group', true)}
        unlockPhrase={group.name}
      />
    </>
  )
}

export default GroupSettings
